import AssetsManager from '../../../data/AssetsManager'
import DataManager from '../../../data/DataManager'
import WallView from './WallView'

/**
 * RouteViewクラス
 */
class RouteView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	WallView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(prevRoute) {
    super()

    //app参照
    this.app = DataManager.getData('app')

    //コンフィグ
    this.config = AssetsManager.getConfig()

    //変数定義
    this.routeX = 0
    this.routeWidth = 500
    this.routeHeight = 800

    //前のルートがある場合
    if(prevRoute)
    {
      //全体の位置を調整
      this.y = prevRoute.y - prevRoute.height + 10

      //幅と高さをランダムにする
      this.routeWidth = Math.round((500 + Math.random()*120)/2)*2
      this.routeHeight = 300 + Math.floor(Math.random()*300)

      //前のルートの中心とのずれをランダムに設定
      let saX = 0
      let zureX = 0
      do{
        zureX = Math.floor((100 + Math.random()*300)/2)*2
        if(Math.random()*100 < 50) zureX *= -1
  
        //ルートの中心
        this.routeX = prevRoute.routeX + zureX
        if(this.routeX < - this.config.STAGE_WIDTH)
        {
          this.routeX = -this.config.STAGE_WIDTH
        }
        else if(this.routeX >  this.config.STAGE_WIDTH)
        {
          this.routeX = this.config.STAGE_WIDTH
        }

        saX = Math.abs(prevRoute.routeX - this.routeX)
  
      }while(saX <= 100)

      //中間点の左端と右端を算出
      let minX = Math.min(prevRoute.minX, this.routeX - this.routeWidth/2)
      let maxX = Math.max(prevRoute.maxX, this.routeX + this.routeWidth/2)

      //中間用の設定
      const connectRouteX = minX + (maxX - minX)/2
      const connectRouteWidth = (maxX - minX)
      const connectRouteHeight = 600 + Math.floor(Math.random()*200)

      //中間ルート配置
      const connectWall = new WallView(connectRouteWidth, connectRouteHeight)
      connectWall.x = connectRouteX
      connectWall.y = -connectRouteHeight
      this.addChild(connectWall)

      //通常ルート配置
      this.wall = new WallView(this.routeWidth, this.routeHeight)
      this.wall.x = this.routeX
      this.wall.y = -connectWall.height + 10 - this.routeHeight
      this.addChild(this.wall)
    }
    //最初のルート
    else
    {
      this.wall = new WallView(this.routeWidth, this.routeHeight)
      this.wall.x = 0
      this.wall.y = -this.routeHeight
      this.addChild(this.wall)
    }
  }

  get minX()
  {
    return this.wall.x - this.wall.w/2
  }

  get maxX()
  {
    return this.wall.x + this.wall.w/2
  }

  hitTestPlayer(player)
  {
    let hitFlag = false
    let len = this.children.length
    for(let i=0; i<len; i++)
    {
      const wall = this.getChildAt(i)
      if(wall.hitTestPlayer(player))
      {
        hitFlag = true
        break
      }
    }

    return hitFlag
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default RouteView
